import React from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'

import '../assets/css/app.css';
import Footer from '../components/Footer';
const Layout = ({ children }) => {
    return (
        <React.Fragment>
            <Navbar />
            <div className="container">
                <div className="columns ">

                    <Sidebar />


                    <div className="column is-9 pl-5 ml-3">
                        {children}
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment >
    )
}

export default Layout